// PhoneInput.tsx · v12.10.26 (#2135 the app's one phone input for every mobile field - T2_UI_PRINCIPLES §38) · 2026-10-30 · VoiceSpectrum AI
// v12.10.26 (#2135): blank until the first digit, then the mask "+1 (908) 555-0142"; +1 / 1 / spaces / dashes / dots / brackets and pasted
// text are all read; Backspace walks through the mask. The VALUE is the draft lib/phone keeps: "+1XXXXXXXXXX" when complete, the national
// digits while typing, foreign text as typed. The error is worked out from the value on every render - never a stale message.
import type { CSSProperties } from 'react';
import { isForeign, maskPhone, ONLY_US_CANADA, phoneFromInput, toE164 } from '../lib/phone';

/** v12.10.26 (#2135): the error under a mobile box. "Only US and Canada" shows at once; "incomplete" waits until the person left the
 *  field or pressed Send (<paramref name="touched"/>). '' when blank or complete. */
export function mobileFieldError(value: string, touched: boolean, incompleteText = 'Enter a 10-digit mobile number.'): string {
  const t = (value ?? '').trim();
  if (!t || toE164(t)) return '';
  if (isForeign(t)) return ONLY_US_CANADA;
  return touched ? incompleteText : '';
}

export default function PhoneInput({ id, value, onChange, onBlur, placeholder = '+1 (___) ___-____', disabled, className, style, invalid }: {
  id?: string; value: string; onChange: (draft: string) => void; onBlur?: () => void; placeholder?: string; disabled?: boolean;
  className?: string; style?: CSSProperties; invalid?: boolean;
}) {
  return (
    <input id={id} type="tel" inputMode="tel" autoComplete="off" className={className} style={style} placeholder={placeholder}
      value={maskPhone(value)} disabled={disabled} aria-invalid={invalid || undefined}
      onChange={(e) => onChange(phoneFromInput(e.target.value, value))} onBlur={onBlur} />
  );
}
